import LastUpdated from './LastUpdated';

export default LastUpdated;
